import React from 'react';
import {
    withStyles,
    Grid,
    withRouter,
} from '../../material-ui';
 
import MBack from '../view/MBack';
import MSnackbar from '../view/MSnackbar';
import AppUtils from '../../control/apputlis';
import ChatBookItem from './ChatBookItem';
import MNoLiving from '../view/MNoLiving';
import FIMUtils from '../../im/FIMUtils';



const ICON_SEARCH = require('../../images/icons/icon_search.png');

class ChatBook extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchVal: '',
            data: [],
            searchData: [],
        };
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'ChatGroup');
        let data = FIMUtils.getFriendList();
        this.setState({ data: data });
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _onSearchClick = (value) => {
        console.log('_onSearchClick');
        this.setState({ searchVal: value }, () => {
            this.searchUser();
        });
    }

    searchUser = () => {
        let { data, searchVal } = this.state;
        if (data.length == 0) {
            return;
        }

        let searchUser = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i].userID.indexOf(searchVal) >= 0 || data[i].profile.nick.indexOf(searchVal) >= 0) {
                searchUser.push(data[i]);
            }
        }
        this.setState({ searchData: searchUser });
    }

    onClickItem = (item) => {
        let userId = item.userID;
        let nick = item.profile.nick;
        this.props.history.push({ pathname: '/privateletter/' + userId + '/userProfile', data: nick });
    }

    renderItem = (item, i) => {
        return (
            <ChatBookItem key={i} data={item} onClick={() => this.onClickItem(item)} />
        );
    }

    renderEmpty = () => {
        return (
            <Grid container justifycontent='center' alignItems='center' style={{ marginTop: 64 }}>
                <MNoLiving title='暂无好友' />
            </Grid>
        );
    }

    render() {
        const { classes } = this.props;
        const { searchVal, data, searchData } = this.state;
        let tmpData = searchVal.length > 0 ? searchData : data;
        return (
            <MBack title='通讯录'>
                <Grid container direction='row' style={{ height: 32 }}></Grid>
                <Grid container direction='column' alignItems='center' className={classes.container}>
                    <Grid container direction='row' alignItems='center' justifycontent='center' className={classes.searchView}>
                        <img src={ICON_SEARCH} style={{ width: 18, height: 18, marginLeft: 8 }}></img>
                        <form action="">
                            <input 
                                type="search"
                                onChange={event => this._onSearchClick(event.target.value)}
                                value={searchVal}
                                className={classes.searchInput}
                                placeholder='搜索' />
                        </form>
                    </Grid>
                    <Grid container direction='column' style={{ width: '100%', marginTop: 16 }}>
                        {tmpData.length == 0 && this.renderEmpty()}
                        {
                            tmpData.length > 0 && data.map((item, i) => (
                                this.renderItem(item, i)
                            ))
                        }
                    </Grid>
                </Grid>
                <MSnackbar ref={(ref) => { this.toast = ref }} />
            </MBack >
        );
    }
}
export default withRouter(withStyles((theme) => ({
    container: {
        width: '100vw',
        padding: theme.spacing(0, 1.5, 0, 1.5),
    },
    searchView: {
        backgroundColor: '#F2F2F2',
        width: 'calc(100vw - 24px)',
        height: 32,
        borderRadius: 8,
    },
    searchInput: {
        flex: 1,
        width: '100%',
        height: '100%',
        margin: theme.spacing(0, 0, 0, 1),
        backgroundColor: 'transparent',
        justifyContent: 'center',
        border: 'none',
        outline: 'none',
        color: '#0D0D0D',
        fontSize: theme.typography.pxToRem(13),
    },
    searchButton: {
        width: '100%',
        height: 32,
        backgroundColor: '#2E2E2E',
        borderRadius: 8,
        width: 'calc(100vw - 24px)',
    }
}))(ChatBook));
